<template>
  <v-container class="white-wrapper" fluid>
    <div class="config-title" style="max-width: 25rem; margin: 0 auto">
      <router-link to="/config" class="back-icon">
        <v-btn icon large>
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">Trade History</div>
    </div>
    <div class="panels-container">
      <template v-if="list.length === 0">
        <div class="item-wrapper justify-center">{{$t('config.PaymentHistoryNone')}}</div>
      </template>
      <template v-else>
        <template v-for="(item, idx ) in list">
          <v-card
            :key="item.tradeId"
            class="shadow-10-30"
            style="padding: 1.3rem; margin-bottom: 1.3rem"
            v-if="!isLoading || list.length !== 0"
          >
            <div class="my-2">
              <div class="type-wrapper">
                <div class="date-wrapper mb-1">
                  {{
                    $moment(item.businessDate).format('YYYY-MM-DD')
                  }}
                </div>
                <template v-if="item.up_type === 0">
                  <div style="color: #f65b5b">
                    {{ item.tradeId }}
                  </div>
                </template>
                <template v-else>
                  <div style="color: #4472d9">
                    {{ item.tradeId }}
                    
                  </div>
                </template>
              </div>
              <div class="type-wrapper">
                <div>
                  {{ tradeTxt(item.tradeType) }}
                </div>
                <div>
                  <img style="position: relative;top: 4px;width:20px;" :src="imgSrc(item.currency)" />

                  {{ comma(item.amount) + item.currency }}
                </div>
              </div>
              <div class="type-wrapper">
                <div class="content-wrapper">
                  {{ item.up_content }} 
                </div>
              </div >
            
            </div>
          </v-card>
        </template>
      </template>

      <div class="d-flex justify-center align-center" style="min-height: 2rem">
        <v-btn
          v-show="!noMore"
          @click="getMore"
          color="primary"
          class="font-weight-bold"
          text
        >
          {{ $t('point.more') }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      o2list : {} , 
      noMore: false,
      page: 1,
      size: 5
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.loading
    }
  },
  created() {
    this.$store.commit('loading', true)
    this.callAPI()
  },
  methods: {
     
    tradeTxt(tradeType){
       // - 거래유형(100:충전,110:현금인출,120:입금,121:이체,150:우선승인,151:지불,200:정산,300:잔액조회,500:수수료)
      let tradeTypeObj = {          
          "100":"충전","110":"현금인출","120":"입금","121":"이체","150":"우선승인","151":"지불","200":"정산","300":"잔액조회","500":"수수료"
      } ;    

      return (tradeTypeObj[tradeType])? tradeTypeObj[tradeType] : 'None';
    } , 

    imgSrc(item) {
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },
    callAPI() {
      const params = {
        // tid : this.$store.getters.user.id  ,
        page: this.page,
        size: this.size
      }
      this.$store.commit('loading', true)
      this.$store
        .dispatch('tradeHistory', params)
        .then((res) => {
          this.$store.commit('loading', false) ; 

          if (res.status === 200 && res.data.code=='200'  ) {
           
            if(  res.data.data.length > 0 ) {
              const arr = res.data.data ; 
              this.list = this.list.concat(arr)  ;   
              if (arr.length < this.size) this.noMore = true

            }else  {
              this.noMore = true
            } 
  
          } else throw res.data.msg || this.$t('errorServer')
        })
        .catch((err) => {
          console.log("err: " , err ) ; 

          this.$store.commit('loading', false)
          this.$store.dispatch('toast', {
            toast: true,
            // toast_msg: this.$t('errorServer'),
            toast_msg:err , 
            timeout: 2000
          })
          // console.log(err)
        })
    },
    getMore() {
      this.page = this.page + 1
      this.callAPI()
    }
  }
}
</script>

<style scoped>
.item-wrapper {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.85rem;
  min-height: 3rem;
}
.date-wrapper {
  font-size: 0.8rem;
  color: #cbcbcb;
  font-weight: 500;
}
.type-wrapper {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
.content-wrapper {
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
}
.unpaid-text {
  text-decoration: underline;
  text-underline-offset: 3px;
}
</style>
